(() => {
  const body = document.body;
  const toggle = document.querySelector('[data-menu-toggle]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  const close = document.querySelector('[data-menu-close]');
  const setMenu = (open) => {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    body.classList.toggle('menu-open', open);
    toggle?.setAttribute('aria-expanded', String(open));
  };
  toggle?.addEventListener('click', (event) => { event.preventDefault(); setMenu(true); });
  close?.addEventListener('click', (event) => { event.preventDefault(); setMenu(false); });
  drawer?.addEventListener('click', (event) => { if (event.target === drawer) setMenu(false); });
})();

(() => {
  const initProduct = (scope = document) => {
    scope.querySelectorAll('[data-product-page]').forEach((page) => {
      if (page.dataset.productReady === 'true') return;
      page.dataset.productReady = 'true';
      const gallery = page.querySelector('[data-product-gallery]');
      gallery?.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const activeIndex = thumb.dataset.galleryThumb;
          gallery.querySelectorAll('[data-gallery-image]').forEach((item) => {
            item.hidden = item.dataset.galleryImage !== activeIndex;
            if (item.hidden) item.querySelectorAll('video').forEach((video) => video.pause());
          });
          gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
            const active = item === thumb;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
        });
      });
      const variants = page.querySelector('.sh-option select[name="id"]');
      variants?.addEventListener('change', () => {
        const price = page.querySelector('[data-product-price]');
        const selected = variants.selectedOptions[0];
        if (price) price.textContent = selected?.dataset.price || price.textContent;
        const available = selected?.dataset.available === 'true';
        const button = page.querySelector('.sh-add-to-cart');
        if (button) button.disabled = !available;
        const label = page.querySelector('[data-add-to-cart-label]');
        if (label) label.textContent = available ? 'أضف للسلة' : 'نفد مؤقتًا';
        const availability = page.querySelector('[data-product-availability]');
        availability?.querySelector('.sh-product-info__dot')?.classList.toggle('is-unavailable', !available);
        const availabilityText = page.querySelector('[data-product-availability-text]');
        if (availabilityText) availabilityText.textContent = available ? 'متاح للطلب' : 'غير متاح حاليًا';
      });
    });
  };
  initProduct();
  document.addEventListener('shopify:section:load', (event) => initProduct(event.target));
})();

(() => {
  const initTabs = (scope = document) => {
    scope.querySelectorAll('[data-collection-tabs]').forEach((section) => {
      if (section.dataset.tabsReady === 'true') return;
      section.dataset.tabsReady = 'true';
      const tabs = [...section.querySelectorAll('[role="tab"]')];
      const activate = (tab, focus = false) => {
        tabs.forEach((item) => {
          const selected = item === tab;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
        if (focus) tab.focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex;
          if (event.key === 'ArrowLeft') nextIndex = (index + 1) % tabs.length;
          else if (event.key === 'ArrowRight') nextIndex = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = tabs.length - 1;
          else return;
          event.preventDefault();
          activate(tabs[nextIndex], true);
        });
      });
    });
  };
  initTabs();
  document.addEventListener('shopify:section:load', (event) => initTabs(event.target));
})();
